import { useRecoilState } from "recoil";
import { isShortCutCheckModalOpenState } from "../../../recoil/admin/examRoom";
import Modal from "../../modules/layout/Modal";
import React, { useEffect, useRef, useState } from "react";
import useEvaluationActions from "../../../api/hooks/rater/evaluation";
import { useMutation, useQuery } from "@tanstack/react-query";
import { getHostUrl } from "../../../utils";
import dayjs from "dayjs";
import { EVALUATION_ITEM_TYPE } from "../../../submodules/enum/type";
import { SERVER_IP } from "../../../static/server";
import QuestionNumberBox from "../../atoms/buttons/QuestionNumberBox";
import { examTrim } from "../../../api/examTrim";

const RaterShortCutModal = ({ examData, setExamData }) => {
  const [sendData, setSendData] = useState();
  const [evaluateIndex, setEvaluateIndex] = useState(1);
  const [textarea1, setTextarea1] = useState("");
  const [textarea2, setTextarea2] = useState("");
  const [textarea3, setTextarea3] = useState("");

  const [isShortCutCheckModalOpen, setShortCutCheckModalOpen] = useRecoilState(
    isShortCutCheckModalOpenState
  );
  const evaluationActions = useEvaluationActions();
  const [isComment, setIsComment] = useState();
  const [commentText, setCommentText] = useState("");
  const addComment = async (comment) => {
    if (comment.comment.trim() !== "") {
      setCommentText("");
      const res = await evaluationActions.postRaterComment2(comment);
      getComment(sendData, evaluateIndex - 1);
    }
  };

  const [receivedData, setReceivedData] = useState();
  const [tester_sn, setTester_sn] = useState();
  const [combo_sn, setCombo_sn] = useState();
  // console.log("examData.sn", examData.sn);
  const { data: imsi } = useQuery({
    queryKey: ["imsi"],
    queryFn: () =>
      evaluationActions.getEvaluationComboNumber({
        sn: examData.sn,
      }),
    onSuccess: (result) => {
      // console.log("result.data :", result.data);
      setTester_sn(result.data.tester_sn);
      setCombo_sn(result.data.combo_sn);
      for (let dataKey in result.data.raterText) {
        if (result.data.raterText[dataKey].item_type === 1) {
          result.data.raterText[dataKey].score = parseInt(
            result.data.raterText[dataKey].score
          );
        }
      }

      for (let dataKey in result.data.anotherRaterText) {
        if (result.data.anotherRaterText[dataKey].item_type === 1) {
          result.data.anotherRaterText[dataKey].score = parseInt(
            result.data.anotherRaterText[dataKey].score
          );
        }
      }

      // 평가한 문제 수
      var question_number =
        result.data.raterText.length / result.data.question.length;
      result.data.raterText = division(result.data.raterText, question_number);
      result.data.anotherRaterText = division(
        result.data.anotherRaterText,
        question_number
      );

      var final = [];
      for (var i0 = 0; i0 < result.data.question.length; i0++) {
        final.push({
          question: result.data.question[i0],
          raterText: result.data.raterText[i0],
          anotherRaterText: result.data.anotherRaterText[i0],
          answerList: result.data.answerList[i0],
        });
      }
      setReceivedData(final);
    },
    enabled: !!isShortCutCheckModalOpen,
    // staleTime: Infinity,
    refetchOnWindowFocus: false,
  });

  //문항 번호 평가 문항 번호 생성 로직
  const evaluateNumberBox = (evaluateIndexNumber) => {
    const rows = [];
    for (let i = 1; i <= evaluateIndexNumber; i++) {
      rows.push(
        <QuestionNumberBox
          key={i}
          index={i}
          active={i === evaluateIndex}
          onClick={() => {
            setEvaluateIndex(i);
            getComment(sendData, i - 1);
          }}
        />
      );
    }

    return rows;
  };

  const getComment = async (req, i) => {
    const res = await evaluationActions.getRaterCommentList({
      tester_sn: req.tester_sn,
      question_sn: req.comboList[i].question_sn,
    });
    if (res.status === 200) {
      console.log("getComment", res.data);
      setIsComment(res.data);
    }
  };

  useEffect(() => {
    try {
      const req = {
        tester_sn: tester_sn,
        combo_sn: combo_sn,
        comboList: [
          {
            question_sn: receivedData[0].question.question_sn,
            ratingList: receivedData[0].raterText,
          },
          {
            question_sn: receivedData[1].question.question_sn,
            ratingList: receivedData[1].raterText,
          },
          {
            question_sn: receivedData[2].question.question_sn,
            ratingList: receivedData[2].raterText,
          },
        ],
      };
      console.log("receivedData req", receivedData, req);
      setSendData(req);
      setTextarea1(receivedData[0].raterText[4].score);
      setTextarea2(receivedData[1].raterText[4].score);
      setTextarea3(receivedData[2].raterText[4].score);
      getComment(req, evaluateIndex - 1);
    } catch (error) {
      // console.log("error", error);
    }
  }, [receivedData]);

  const division = (divisionArray, sliceCount) => {
    const length = divisionArray.length;
    const divide =
      Math.floor(length / sliceCount) +
      (Math.floor(length % sliceCount) > 0 ? 1 : 0);
    const newArray = [];
    for (let i = 0; i < divide; i++) {
      // 배열 0부터 n개씩 잘라 새 배열에 넣기
      newArray.push(divisionArray.splice(0, sliceCount));
    }
    return newArray;
  };

  const evaluateChange = (item, raterTextRow) => {
    const changedEvaluate = sendData;
    changedEvaluate.comboList[evaluateIndex - 1].ratingList[
      raterTextRow
    ].score = item;
    setSendData(changedEvaluate);
  };

  const mutation = useMutation(evaluationActions.setRevaluation, {
    onSuccess: () => {
      alert("실행성공.");
      setShortCutCheckModalOpen(false);
      return;
    },
    onError: () => {
      alert("실패");
    },
  });

  // console.log("receivedData", receivedData);
  return receivedData === undefined || sendData === undefined ? (
    <></>
  ) : (
    <Modal isOpen={isShortCutCheckModalOpen}>
      <div className="modal fade" id="ShortCut" style={{ display: "block" }}>
        <div className="modal-content" style={{ width: "1400px" }}>
          <div className="modal-body confirm-sec rater-section">
            <div className="white-section">
              <div className="QnA">
                <p style={{ whiteSpace: "pre-wrap", wordBreak: "break-all" }}>
                  Q.
                  {examTrim(receivedData[evaluateIndex - 1]?.question?.text)}
                </p>
              </div>
              <div>
                {receivedData[evaluateIndex - 1]?.answerList ? (
                  <video
                    className="rater-video-fix"
                    src={`${SERVER_IP}/${
                      receivedData[evaluateIndex - 1]?.answerList
                    }`}
                    controls
                  />
                ) : (
                  <video />
                )}
                <div
                  style={{
                    position: "absolute",
                    marginLeft: "10px",
                    display: "inline-block",
                  }}
                >
                  {evaluateNumberBox(3)}
                </div>
              </div>

              <div className="rater-shortcut-grade">
                <div>
                  <div className="border-line"></div>
                  <div>
                    {receivedData[evaluateIndex - 1]?.raterText.map(
                      (raterTextType, raterTextRow) => {
                        return (
                          <>
                            <div className="question-box flex">
                              <div className="question-title">
                                <p>{raterTextType.title}</p>
                              </div>
                              {/* 객관식, 주관식 */}
                              {raterTextType.item_type ===
                              EVALUATION_ITEM_TYPE.CHOICE ? (
                                <div className="score-btn">
                                  {[1, 2, 3, 4, 5].map((item) => {
                                    return (
                                      <button
                                        onClick={() => {
                                          evaluateChange(item, raterTextRow);
                                          setEvaluateIndex(0);
                                          setTimeout(() => {
                                            setEvaluateIndex(evaluateIndex);
                                          }, 10);
                                        }}
                                        type="button"
                                        className={
                                          raterTextType.score === item &&
                                          receivedData[evaluateIndex - 1]
                                            .anotherRaterText[raterTextRow]
                                            .score === item
                                            ? "score-number active preOn"
                                            : raterTextType.score === item
                                            ? "score-number active"
                                            : receivedData[evaluateIndex - 1]
                                                .anotherRaterText[raterTextRow]
                                                .score === item
                                            ? "score-number preOn"
                                            : "score-number"
                                        }
                                      >
                                        {item}
                                      </button>
                                    );
                                  })}
                                </div>
                              ) : (
                                <textarea
                                  style={{ resize: "none" }}
                                  value={
                                    evaluateIndex - 1 === 0
                                      ? textarea1
                                      : evaluateIndex - 1 === 1
                                      ? textarea2
                                      : textarea3
                                  }
                                  className="q-insert-input motto-input mb-10"
                                  placeholder="평가 내용 입력"
                                  onChange={(e) => {
                                    evaluateChange(
                                      e.target.value,
                                      raterTextRow
                                    );
                                    if (evaluateIndex - 1 === 0)
                                      setTextarea1(e.target.value);
                                    if (evaluateIndex - 1 === 1)
                                      setTextarea2(e.target.value);
                                    if (evaluateIndex - 1 === 2)
                                      setTextarea3(e.target.value);
                                  }}
                                />
                              )}
                            </div>
                          </>
                        );
                      }
                    )}
                  </div>
                  <div className="border-line"></div>
                </div>
              </div>
            </div>
            <div className="white-section">
              <div>
                <div className="rater-opinion-box" style={{ margin: "0" }}>
                  <div className="evalation-box short-evalation-box">
                    <div className="evalation-title">
                      <p>평가자 의견교환</p>
                    </div>
                    <div className="border-line"></div>

                    <div className="comment-box text-align-right">
                      <textarea
                        placeholder="코멘트 남기기"
                        value={commentText}
                        onChange={(e) => setCommentText(e.target.value)}
                      />
                      <button
                        type="button"
                        className="comment-insert-btn"
                        onClick={() => {
                          addComment({
                            comment: commentText,
                            tester_sn: tester_sn,
                            question_sn:
                              sendData.comboList[evaluateIndex - 1].question_sn,
                          });
                        }}
                      >
                        등록
                      </button>
                    </div>

                    <div className="overflow-scroll height-486">
                      {isComment?.map((data) => {
                        return (
                          <div className="comment-show" key={data.sn}>
                            <p className="grade-rater">
                              <span className="comment-user">{data.name}</span>
                              <span
                                className="commnet-date"
                                style={{ float: "right" }}
                              >
                                {dayjs(data.create_time).format(
                                  "YYYY/MM/DD HH:mm"
                                )}
                              </span>
                            </p>
                            <p className="comment-cont">{data.comment}</p>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
              <div className="border-line"></div>
              <div className="guide-comment text-align-center">
                <p> 평가 후 '저장'을 클릭해야 저장됩니다.</p>
              </div>
            </div>
            <div
              className="modal-footer text-align-right"
              style={{ marginRight: 40 }}
            >
              <button
                type="button"
                className="modal-btn modal-close-btn"
                onClick={() => {
                  setShortCutCheckModalOpen(false);
                }}
              >
                닫기
              </button>
              <button
                className="modal-btn modal-save-btn"
                onClick={() => {
                  mutation.mutate(sendData);
                }}
              >
                저장
              </button>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};
export default RaterShortCutModal;
